import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';

import PatientRow from './patientRow';
import Sorting from './sorting';

const Patients = ({ patients, count, loading }) => {
  return (
    <div className="onboarding-table">
      <Card className="card-border">
        <CardBody>
          <div className="onboarding-body">
            <div className="sort-row">
              <Sorting count={count} data={patients} />
            </div>
            {withLoader(
              loading,
              <div className="table-outer">
                <table>
                  <thead>
                    <tr>
                      <th>Patient Name</th>
                      <th>MRN</th>
                      <th>DOB</th>
                      <th>State</th>
                      <th>Phone Number</th>
                      <th>Clinic Name</th>
                      <th>Provider</th>
                      <th>Provider Email</th>
                      <th>Insurance Type</th>
                      <th>Insurance Provider</th>
                      <th>Insurance Number</th>
                      <th>CCM Status</th>
                      <th>RPM Status</th>
                      <th>PCM Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patients.map((patientRow, index) => (
                      <PatientRow key={index} patient={patientRow} />
                    ))}
                  </tbody>
                </table>
              </div>,
            )}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

Patients.propTypes = {
  patients: PropTypes.array,
  count: PropTypes.number,
  loading: PropTypes.bool,
};

export default Patients;
